export enum RateMeasurementUnit {
  PER_CBM = 'per_cbm',
  PER_MT = 'per_mt',
  PER_UNIT = 'per_unit',
  PER_WM = 'per_wm',
  PER_MAFI = 'per_mafi',
  LUMPSUM = 'lumpsum'
}
